/* ------------------------------------------------------------
   EcomIQ - site-wide booking-CTA fallback, for labels such as
   "Talk to a coach" or "Talk to a strategist".
   Loaded from layout/theme.liquid, so it covers every template
   including ones added later.

   HISTORY, worth keeping. This file used to open a Klaviyo popup
   (form RBetFu) for any element whose text read "talk to a coach".
   Booking moved to HighLevel, so it now sends people to the
   booking page in a new tab instead. The set of matched labels has
   also grown since then; PHRASES below is the only list that
   matters, and several wordings match at once.

   Klaviyo is NOT gone entirely. Bookings left; the free community
   signup and the newsletter stayed. So this file does two separate
   jobs: send booking CTAs to HighLevel, and open a Klaviyo popup
   for any link written as href="#klaviyo-form-XXXX".

   It is now a FALLBACK, not a hijacker. The EcomIQ sections render
   a real href to the booking page themselves, so this script
   deliberately ignores any link that already has a working href and
   lets the browser do its job. It only steps in for a button or a
   placeholder link that would otherwise go nowhere, which is what
   happens when someone adds a "Talk to a coach" or "Talk to a
   strategist" button in the theme editor without setting a
   destination.

   Deliberately skipped:
   - anything that already has a real href, so section buttons and
     hand-set links are never intercepted
   - anything inside a Klaviyo form or its reset-css wrapper, so the
     newsletter signup on Resources still submits normally
   - anything inside a <form>, same reason
   ------------------------------------------------------------ */
(function () {
  if (window.__eiqCtaBound) return;
  window.__eiqCtaBound = true;

  var BOOKING_URL = 'https://api.leadconnectorhq.com/widget/booking/vxCqs0Bz3DPhSmnHKYwj';
  var PHRASES = ['talk to a coach', 'talk to a strategist', 'book a call', 'choose a time'];

  function normalise(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isTarget(el) {
    var t = normalise(el);
    if (!t || t.length > 40) return false;
    for (var i = 0; i < PHRASES.length; i++) {
      if (t === PHRASES[i]) return true;
    }
    return false;
  }

  // True when the anchor already points at the booking page, in which
  // case leave it entirely alone. Letting the browser handle it keeps
  // middle-click, ctrl-click and "open in new tab" working, which
  // calling window.open ourselves would break.
  function isBookingHref(el) {
    if (el.tagName !== 'A') return false;
    var href = el.getAttribute('href') || '';
    return href.indexOf('api.leadconnectorhq.com/widget/booking/') !== -1;
  }

  // Never interfere with a real form, or with Klaviyo's own markup.
  // The newsletter signup on Resources has to keep submitting.
  function insideForm(el) {
    if (!el.closest) return false;
    if (el.closest('[class*="klaviyo-form-"]')) return true;
    if (el.closest('[class*="kl-private-reset-css"]')) return true;
    if (el.closest('form')) return true;
    return false;
  }

  function openBooking() {
    // noopener matters: without it the new tab can reach back into
    // this page through window.opener.
    var win = window.open(BOOKING_URL, '_blank', 'noopener');
    if (win) {
      win.opener = null;
    } else {
      // Popup blocked. Falling back to the same tab is better than
      // the click doing nothing at all.
      window.location.href = BOOKING_URL;
    }
  }

  /* --------------------------------------------------------
     Klaviyo popups, for the things that are NOT bookings.

     Booking moved to HighLevel, but the free community signup is
     still a Klaviyo popup. The theme's header and footer sections
     store their CTA destinations as plain URL strings, so there is
     nowhere to hang a data attribute. They already use the
     convention href="#klaviyo-form-XXXX", so that is honoured here
     as a real instruction rather than left as a dead anchor.

     Without this the browser simply tries to jump to an element
     with that id, finds nothing, and the click appears to do
     nothing at all. That is exactly how the footer community
     button was failing.
     -------------------------------------------------------- */
  var KL_HREF = /^#klaviyo-form-([A-Za-z0-9_-]+)$/;

  function klaviyoIdFrom(el) {
    var a = el.closest ? el.closest('a[href]') : null;
    if (!a) return '';
    var m = KL_HREF.exec((a.getAttribute('href') || '').trim());
    return m ? m[1] : '';
  }

  function openKlaviyo(id) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }

  function onClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var el = target.closest('a,button');
    if (!el) return;
    if (insideForm(el)) return;

    /* A booking CTA always goes to HighLevel. This test runs FIRST,
       ahead of the Klaviyo href handler below, and that order is the
       whole point: it means a button reading "Talk to a coach" or
       "Talk to a strategist" can never open a Klaviyo popup, no
       matter what its link says. If someone points one at
       "#klaviyo-form-XXXX", by hand or by re-enabling an old
       section, it still goes to booking.

       Klaviyo popups remain available to everything else, which is
       how the free community button keeps working. */
    if (isTarget(el)) {
      if (isBookingHref(el)) return;
      event.preventDefault();
      openBooking();
      return;
    }

    var klId = klaviyoIdFrom(el);
    if (klId) {
      event.preventDefault();
      openKlaviyo(klId);
      return;
    }
  }

  document.addEventListener('click', onClick);

  /* --------------------------------------------------------
     Force booking links to open in a new tab.

     The EcomIQ sections set target="_blank" themselves, but the
     header and footer CTAs are theme sections whose link fields
     emit a plain href with no target. Rather than fork those
     shared sections, any anchor pointing at the booking page is
     upgraded here. Runs on load and again on DOM changes, so
     links added later by the theme editor are covered too.
     -------------------------------------------------------- */
  function upgradeBookingLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links;
    try {
      links = scope.querySelectorAll('a[href*="api.leadconnectorhq.com/widget/booking/"]');
    } catch (e) {
      return;
    }
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('target') === '_blank') continue;
      a.setAttribute('target', '_blank');
      var rel = a.getAttribute('rel') || '';
      if (rel.indexOf('noopener') === -1) {
        a.setAttribute('rel', (rel + ' noopener').trim());
      }
    }
  }

  function ready() {
    upgradeBookingLinks(document);
    if (window.MutationObserver && document.documentElement) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        (window.requestAnimationFrame || window.setTimeout)(function () {
          queued = false;
          upgradeBookingLinks(document);
        }, 0);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
